// extracted by mini-css-extract-plugin
module.exports = {"otherJobContentInfo__title":"otherJobContentInfo__title"};